import { C } from "@/brand/tokens";
import { process6 } from "@/brand/contentF6";
import { Box6 } from "@/components/common/Box6";

/**
 * ProcessSteps6 — four boxed, numbered steps side by side on desktop,
 * stacked on mobile. Reused on the homepage and the Contact page.
 */
export function ProcessSteps6({ tone = "parchment", testId = "process-grid-6" }) {
  const bodyColor = tone === "blue" || tone === "ink" || tone === "glass" ? C.whiteOnDark : C.inkOnLight;
  return (
    <ol className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4" data-testid={testId}>
      {process6.steps.map((s, i) => (
        <Box6
          as="li"
          key={s.n}
          tone={tone}
          radius="resource"
          className="p-6 lg:p-7 flex flex-col"
          data-testid={`process-step-${i}`}
        >
          <span
            className="font-cormorant tabular-nums"
            style={{ color: C.accentMetal, fontSize: "2.1rem", lineHeight: 1 }}
          >
            {s.n}
          </span>
          <h3
            className="mt-5 font-cormorant"
            style={{ fontSize: "1.3rem", lineHeight: 1.15, fontWeight: 400 }}
          >
            {s.label}
          </h3>
          <p className="mt-3 font-inter leading-[1.6]" style={{ color: bodyColor, fontSize: "0.9rem" }}>
            {s.body}
          </p>
        </Box6>
      ))}
    </ol>
  );
}
